/**
 * normalizeAntdLocale 兼容 Vite 将 `antd/locale/*` 转成含 default 的模块命名空间。
 * 必须在合并 Yimoka 扩展文案前解包，否则 Ant Design 6 会二次解包并丢弃顶层扩展字段。
 */
export const normalizeAntdLocale = (localeModule) => (
  localeModule?.default?.locale ? localeModule.default : localeModule
);
